import clsx from 'clsx'
import type { ButtonHTMLAttributes } from 'react'
import Icon from '../Icon/Icon'
import Button from './Button'

interface BackButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Optional title. If not set will only show the icon.
   */
  title?: string
  /**
   * Optional link
   */
  link?: { href: string }
}

export default function BackButton({ title, ...props }: BackButtonProps) {
  return (
    <Button
      {...props}
      overrideClassName
      className={clsx(
        'font-semibold text-[18px] text-neutral-700 rounded-8 border-2 inline-flex items-center justify-center cursor-pointer transition',
        'min-h-[55px] px-2 bg-transparent border-transparent',
        'hover:underline underline-offset-[0.28em]',
        props.className,
      )}
    >
      <Icon icon="arrow-left" className={clsx('w-6 h-6', title && 'mr-4')} />
      {title}
    </Button>
  )
}
